/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputZoneShort } from './OutputZoneShort';
import {
    OutputZoneShortFromJSON,
    OutputZoneShortFromJSONTyped,
    OutputZoneShortToJSON,
} from './OutputZoneShort';

/**
 * 
 * @export
 * @interface OutputAdminDivision
 */
export interface OutputAdminDivision {
    /**
     * 
     * @type {boolean}
     * @memberof OutputAdminDivision
     */
    blocked?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminDivision
     */
    brigadeId?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminDivision
     */
    brigadeName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OutputAdminDivision
     */
    deletable: boolean;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminDivision
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminDivision
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof OutputAdminDivision
     */
    signalEnabled?: boolean;
    /**
     * 
     * @type {Array<OutputZoneShort>}
     * @memberof OutputAdminDivision
     */
    zones?: Array<OutputZoneShort>;
}

/**
 * Check if a given object implements the OutputAdminDivision interface.
 */
export function instanceOfOutputAdminDivision(value: object): boolean {
    if (!('deletable' in value)) return false;
    if (!('id' in value)) return false;
    if (!('name' in value)) return false;
    return true;
}

export function OutputAdminDivisionFromJSON(json: any): OutputAdminDivision {
    return OutputAdminDivisionFromJSONTyped(json, false);
}

export function OutputAdminDivisionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputAdminDivision {
    if (json == null) {
        return json;
    }
    return {
        
        'blocked': json['blocked'] == null ? undefined : json['blocked'],
        'brigadeId': json['brigadeId'] == null ? undefined : json['brigadeId'],
        'brigadeName': json['brigadeName'] == null ? undefined : json['brigadeName'],
        'deletable': json['deletable'],
        'id': json['id'],
        'name': json['name'],
        'signalEnabled': json['signalEnabled'] == null ? undefined : json['signalEnabled'],
        'zones': json['zones'] == null ? undefined : ((json['zones'] as Array<any>).map(OutputZoneShortFromJSON)),
    };
}

export function OutputAdminDivisionToJSON(value?: OutputAdminDivision | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'blocked': value['blocked'],
        'brigadeId': value['brigadeId'],
        'brigadeName': value['brigadeName'],
        'deletable': value['deletable'],
        'id': value['id'],
        'name': value['name'],
        'signalEnabled': value['signalEnabled'],
        'zones': value['zones'] == null ? undefined : ((value['zones'] as Array<any>).map(OutputZoneShortToJSON)),
    };
}

